import { render, staticRenderFns } from "./ecard.vue?vue&type=template&id=9ab35534&scoped=true&"
import script from "./ecard.vue?vue&type=script&lang=js&"
export * from "./ecard.vue?vue&type=script&lang=js&"
import style0 from "./ecard.vue?vue&type=style&index=0&id=9ab35534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab35534",
  null
  
)

export default component.exports